module.exports = "<div [class]=\"alertCssClass\" role=\"alert\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/alert/alert.component.html
// module id = ../../../../../src/app/shared/alert/alert.component.html
// module chunks = main